import React from 'react'

import styles from './Flex.scss';

const Flex = (props) => {
	let classNames = styles.flex;
  let extraStyles = {};

  if(props.move){
    classNames = classNames + ' ' + styles.move
  }

  if(props.break){
    classNames = classNames + ' ' + styles['break-'+props.break]
  }

  if(props.reverse){
    classNames = classNames + ' ' + styles['reverse-'+props.reverse]
  }

  if(props.align=='center'){
    classNames = classNames + ' ' + styles.isCenter
  }
  if(props.align=='start'){
    classNames = classNames + ' ' + styles.isStart
  }

  if(props.gutter){
    extraStyles = { marginLeft: '-'+(props.gutter)+'px', 
                    marginRight: '-'+(props.gutter)+'px'

    }
  }

  return (
  		<div 
          className={classNames} style={extraStyles}>
          {props.children}
        </div>
  )
}

export default Flex



// WEBPACK FOOTER //
// ./src/components/atoms/Flex/index.js